import { render, staticRenderFns } from "./ListaLeisGoogleSearchResult.vue?vue&type=template&id=74e1d82f&scoped=true&"
import script from "./listaLeisGoogleSearchResult.ts?vue&type=script&lang=ts&"
export * from "./listaLeisGoogleSearchResult.ts?vue&type=script&lang=ts&"
import style0 from "./ListaLeisGoogleSearchResult.vue?vue&type=style&index=0&id=74e1d82f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1d82f",
  null
  
)

export default component.exports